import logoDark from "@/assets/branding/bodycodez-logo-dark.png";
import logoLight from "@/assets/branding/bodycodez-logo-light.png";
import logoLightTagline from "@/assets/branding/bodycodez-logo-light-tagline.png";
import logoIcon from "@/assets/branding/bodycodez-icon-stacked.png";

// TODO: Add variant="dark-tagline" when we generate a dark-text version 
// WITH the tagline for invoices and emails on white backgrounds.

interface BrandLogoProps {
  variant: "dark" | "light" | "light-tagline" | "icon";
  className?: string;
}

const logoMap = {
  dark: logoDark,
  light: logoLight,
  "light-tagline": logoLightTagline,
  icon: logoIcon,
};

const dimensionMap: Record<string, { width: number; height: number }> = {
  dark: { width: 200, height: 50 },
  light: { width: 200, height: 50 },
  "light-tagline": { width: 200, height: 70 },
  icon: { width: 80, height: 80 },
};

export const BrandLogo = ({ variant, className }: BrandLogoProps) => {
  return (
    <img
      src={logoMap[variant]}
      alt="bodyCODEZ"
      className={className}
    />
  );
};
